import { useState, useCallback, useEffect, useMemo } from "react";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Me from "../../services/me";
import { useAppContext } from "../../common/ApplicationServicesContext";
import { useNavigate } from "react-router-dom";

const TrainingModal = ({ show, onConfirm }) => {
    const navigate = useNavigate();
    const [translate] = useTranslation();
    const [linkClicked, setLinkClicked] = useState(false);
    const { domain, handleLogout } = useAppContext();

    const getActiveTrainingUrl = useMemo(() =>
        domain.trainingUrls ?
            domain.trainingUrls[domain.trainingUrls?.length - 1] ?? null
            : null
        , [domain]);

    const userConfirmed = useCallback(async () => {
        const response = await Me.completeTraining(getActiveTrainingUrl._id);
        if (!response.error) {
            onConfirm();
        } else {
            handleLogout(navigate);
        }
    }, [onConfirm, handleLogout, getActiveTrainingUrl, navigate]);

    useEffect(() => {
        setLinkClicked(false)
    }, [show]);

    return <BootstrapModal size="md" show={show} backdrop="static">
        <BootstrapModal.Header className="h5 text-secondary">{domain.trainingText?.title || translate("OTM_TRAINING_TITLE")}</BootstrapModal.Header>
        <BootstrapModal.Body>
            <label className="ps-2 h6">
                {domain.trainingText?.text || translate("OTM_TRAINING_DESCRIPTION")}
            </label>
        </BootstrapModal.Body>
        <BootstrapModal.Footer>
            <div className="d-flex flex-row w-100">
                <Button
                    onClick={() => { window.open(getActiveTrainingUrl?.url, '_blank'); setLinkClicked(true); }}
                    variant="secondary"
                    className="btn-sm w-100 me-2"
                >
                    {domain.trainingText?.hyperlinkText || translate("OTM_TRAINING_HYPERLINK")}
                </Button>
                <Button
                    disabled={!linkClicked}
                    onClick={userConfirmed}
                    variant="success"
                    className="btn-sm w-100 ms-2"
                >
                    {domain.trainingText?.completionText || translate("OTM_TRAINING_COMPLETE")}
                </Button>
            </div>

        </BootstrapModal.Footer>
    </BootstrapModal>
};

export default TrainingModal;
